import { EmailPreviewModal } from '@Components/Mailing';
import { type ApiOrder } from '@Model';
import { PrintOptionsModal } from '@Modules/Documents';
import { type AsyncStateUpdate } from '@synqo/frontend-component-library';
import { CashPaymentModal } from '../../CashPaymentModal';
import { type OrderActions } from './useOrderActions';

interface ICollectionProps {
    actions: OrderActions;
    order: ApiOrder;
    totalGrossPrice: number;
    requestUpdateState: AsyncStateUpdate<ApiOrder>;
    refetchData: () => Promise<boolean>;
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function OrderCollectionModal({
    actions,
    order,
    totalGrossPrice,
    requestUpdateState,
    refetchData,
}: ICollectionProps) {
    return (
        <CashPaymentModal
            type="order"
            entity={order}
            currency="€"
            totalGrossPrice={totalGrossPrice}
            isOpen={actions.cashPaymentModal.isOpen}
            close={actions.cashPaymentModal.close}
            onBeforeStartPayment={actions.approveOrder}
            onSuccessfulPayment={(invoices) => {
                void refetchData();
                if (invoices.length === 0) {
                    return;
                }
                actions.previewInvoice(invoices[0].id);
            }}
            requestUpdateState={requestUpdateState}
        />
    );
}

interface IOutputProps {
    actions: OrderActions;
    orderId: string;
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function OrderOutputModals({ actions, orderId }: IOutputProps) {
    const { printOptionsInfo, deliverySlipEmail, invoiceEmail } = actions;
    const { currentPrintOption, setCurrentPrintOption } = printOptionsInfo;

    return (
        <>
            <PrintOptionsModal
                printOption={currentPrintOption}
                sendAsEmail={
                    currentPrintOption?.id === 'invoice'
                        ? () => invoiceEmail.prepareEmail({ invoice_id: currentPrintOption.related_object_id })
                        : () => deliverySlipEmail.prepareEmail({ order_id: orderId })
                }
                onClose={() => setCurrentPrintOption(undefined)}
            />
            <EmailPreviewModal
                isPreparing={deliverySlipEmail.isPreparing}
                emailRequest={deliverySlipEmail.emailRequest}
                setEmailRequest={deliverySlipEmail.setEmailRequest}
            />
            <EmailPreviewModal
                isPreparing={invoiceEmail.isPreparing}
                emailRequest={invoiceEmail.emailRequest}
                setEmailRequest={invoiceEmail.setEmailRequest}
            />
        </>
    );
}
